/**
 * Shared styles for sticky first column with drop shadow effect
 */
export var stickyColumnShadowStyles = {
  "&::after": {
    content: '""',
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    width: "6px",
    transform: "translateX(100%)",
    background: "linear-gradient(to right, rgba(0, 0, 0, 0.07), rgba(0, 0, 0, 0))",
    pointerEvents: "none"
  }
};